import { ResumeScreeningConfig } from '@scale/shared-types';

export const RESULT_COLUMNS = [
  {
    header: 'Email',
    id: 'email',
  },
  {
    header: 'Your Result',
    id: 'expectedResult',
  },
  {
    header: `Screening Result`,
    id: 'actualResult',
  },
];

export enum ResumeScreenListTab {
  ScreeningPipelines = 'Screening Pipelines',
  ScreeningJobs = 'One-off Screening Jobs',
  ResumeSearch = 'Resume Search',
  ResumeMetadata = 'Normalized Resume Terms',
}

export enum ResumeScreeningTestSteps {
  Intro = 0,
  InputEmails = 1,
  InputExpectedResults = 2,
  TestResults = 3,
}

export enum CreateResumeScreeningSteps {
  ImportGreenhouseJob = 0,
  PassActions = 1,
  NeedsHumanReviewActions = 2,
  FailActions = 3,
}

export enum ResumeScreeningAction {
  Pass = 'Pass',
  NeedsHumanReview = 'Human Review',
  Fail = 'Fail',
}

export enum ResumeScreeningActionNodeStatus {
  Active = 'active',
  Inactive = 'inactive',
  Disabled = 'disabled',
}

export const actionTypeMappping: Record<ResumeScreeningAction, keyof ResumeScreeningConfig> = {
  [ResumeScreeningAction.Pass]: 'onPassActions',
  [ResumeScreeningAction.NeedsHumanReview]: 'onUnsupportedFileActions',
  [ResumeScreeningAction.Fail]: 'onFailActions',
};

export enum EmailDripCampaignListTab {
  YourCommunications = 'Your Communications',
  AllCommunications = 'All Communications',
  LifecycleCommunications = 'Lifecycle Communications',
}

export const ALL_EMAIL_DRIP_CAMPAIGN_QUERY_KEY = 'listAllEmailDripCampaigns';
export const YOUR_EMAIL_DRIP_CAMPAIGN_QUERY_KEY = 'listYourEmailDripCampaigns';
export const LIFECYCLE_COMM_TEMPLATES_QUERY_KEY = 'listLifecycleCommTemplates';

export const GROWTH_CENTER_DASHBOARD = 'Growth Center Dashboard';
